import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
// import "./index.scss";
import "./searchRedesign.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetSearchQueryQuery } from "../../services/search";
import Loader from "../../Components/Loader";
import Button from "@mui/joy/Button";
import SearchLoader from "../../Components/SearchLoader";
import { useGetUserDataQuery } from "../../services/login";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import TuneIcon from "@mui/icons-material/Tune";
import { notification } from "antd";
import "antd/dist/antd.min.css";
import SeacrhFilter from "../../Components/SeacrhFilter";
import LoadMoreSkeleton from "../../Components/LoadMoreSkeleton";
import { Helmet } from "react-helmet";
import Host from "../../Components/Host";
import ApisSearchResults from "./ApisSearchResults";
import DbSearchResults from "./DbSearchResults";
import { io } from "socket.io-client";
import { getMetaByCountry } from "../../metaConfig";

function SearchPage() {
  const { userId, userToken, userEmail, languageCode, countryCode, cartToken } = useSelector((state) => state.auth);
  const location = useLocation();
  const { t } = useTranslation();
  const { query } = useParams();
  const limit = new URLSearchParams(location.search).get("size") || 48;
  const searchCountry = new URLSearchParams(location.search).get("country") || null;
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : "";
  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const [getProducts, setProductsData] = useState([]);
  const [getPage, setPage] = useState(1);
  const [getSearchId, setSearchId] = useState(0);
  const [socketId, setSocketId] = useState("");
  const {
    data: newPosts = [],
    isLoading,
    error,
    isError,
    isFetching,
    originalArgs,
  } = useGetSearchQueryQuery(
    {
      page: getPage,
      size: limit,
      query: query,
      search_id: `&search_id=${getSearchId}`,
      countryCode: countryCode,
      searchCountry: thisCountry,
      socketId: socketId,
      cartToken: cartToken,
    },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const products = newPosts?.results;

  React.useEffect(() => {
    if (products?.length > 0) {
      setProductsData((prevPosts) => [...prevPosts, ...products]);
    }
  }, [newPosts]);

  useEffect(() => {
    if (products) {
      setProductsData(() => [...products]);
      setPage(1);
    }
  }, [query, searchCountry]);

  useEffect(() => {
    if (Number(getPage) === 1 && products) {
      setProductsData((prevPosts) => [...products]);
    }
  }, [getPage, products]);

  useEffect(() => {
    if (Number(getPage) === 1 && isFetching) {
      setProductsData((prevPosts) => []);
    }
  }, [getPage, query, searchCountry]);

  const lastId = getProducts?.slice(-1)[0]?.id || 0;

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
    setSearchId(lastId);
  };

  useEffect(() => {
    if (countryCode === "IN") {
      if (window.nitro && typeof window.nitro.categoryView === "function") {
        window.nitro.categoryView({
          category: query,
        });
      } else {
        console.log("Nitro script not loaded");
      }
    }
  }, [query]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  function loadFetch() {
    if (isLoading) {
      return true;
    } else if (isFetching) {
      return true;
    } else {
      return false;
    }
  }

  const [api, contextHolder] = notification.useNotification();
  React.useEffect(() => {
    if (error?.originalStatus === 429) {
      api["error"]({
        message: error?.data,
        showProgress: true,
        pauseOnHover: false,
        duration: 5,
        placement: "top",
      });
    }
  }, [error]);

  const [productUpdates, setProductUpdates] = useState([]);

  const API_URL_NEW = process.env.REACT_APP_AMAZINGE_API_CONNECT;

  useEffect(() => {
    if (!cartToken) return;

    const socket = io(API_URL_NEW, {
      transports: ["websocket"],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 500,
    });

    socket.on("connect", () => {
      console.log("Connected:", socket.id);
      setSocketId(socket.id);

      socket.emit("join-cart", cartToken);
    });

    socket.on("joined-room", (room) => {
      console.log(":", room);
    });

    socket.on("cartUpdate", (data) => {
      console.log("update:");
      setProductUpdates((prev) => [...prev, data?.data]);
    });

    socket.on("disconnect", () => {
      console.warn("Disconnected");
    });

    socket.on("connect_error", (err) => {
      console.error("Error:", err.message);
    });

    return () => {
      socket.off("cartUpdate");
      socket.disconnect();
    };
  }, [cartToken]);

  const [isMetaTitle, setMetaTitle] = useState("");
  const [isMetaDescription, setMetaDescription] = useState("");
  useEffect(() => {
    const { title, description } = getMetaByCountry(countryCode);
    setMetaTitle(title);
    setMetaDescription(description);
  }, [countryCode]);

  const [filtersOpen, setFiltersOpen] = useState(false);
  const filterBtnRef = useRef(null);
  const wasOpen = useRef(false);
  const closeFilters = useCallback(() => setFiltersOpen(false), []);

  useEffect(() => {
    if (wasOpen.current && !filtersOpen && filterBtnRef.current) {
      filterBtnRef.current.focus();
    }
    wasOpen.current = filtersOpen;
  }, [filtersOpen]);

  const searching = loadFetch();
  const resultCount = getProducts?.length || 0;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`${query ? query : ""} ${query && "|"} ${isMetaTitle || Host?.metaTitle}`}</title>
        <meta name="description" content={isMetaDescription || Host?.metaDescription} />
      </Helmet>
      {contextHolder}

      <div className="sp-style sr-page">
        <div className="container">
          <div className="sr-layout">
            <SeacrhFilter
              searchCountry={searchCountry}
              getProducts={getProducts}
              isFetching={isFetching}
              isOpen={filtersOpen}
              onClose={closeFilters}
            />

            <div className="sr-main">
              <div className="row">
                <DbSearchResults userData={userData} />
              </div>

              <header className="sr-head">
                <div>
                  <h1 className="sr-head__title">
                    {searching ? (
                      <>
                        <span>Searching for "{query}"</span>
                        <SearchLoader />
                      </>
                    ) : (
                      <span>Search results for "{query}"</span>
                    )}
                  </h1>
                </div>

                <button
                  ref={filterBtnRef}
                  type="button"
                  className="sr-filter-btn"
                  onClick={() => setFiltersOpen(true)}
                  aria-haspopup="dialog"
                  aria-expanded={filtersOpen}
                  aria-controls="search-filters"
                >
                  <TuneIcon fontSize="small" />
                  {t("filters", "Filters")}
                </button>
              </header>

              {!isLoading && !isFetching && resultCount === 0 && (
                <div className="sr-empty" role="status">
                  <SearchOffIcon className="sr-empty__icon" />
                  <h2 className="sr-empty__title">No results for “{query}”</h2>
                  <p className="sr-empty__text">Check the spelling, try a broader term, or browse a category.</p>
                </div>
              )}

              <div className="sr-grid">
                <ApisSearchResults
                  getProducts={getProducts}
                  userData={userData}
                  isFetching={isFetching}
                  productUpdates={productUpdates}
                />
              </div>

              {searching && (
                <div className="row">
                  <LoadMoreSkeleton />
                </div>
              )}

              {resultCount > 0 && (
                <div className="sr-more">
                  <Button
                    variant="outlined"
                    color="neutral"
                    disabled={isFetching}
                    onClick={loadMore}
                    sx={{
                      height: 44,
                      px: 4,
                      borderRadius: "999px",
                      fontWeight: 600,
                      color: "#2f122e",
                      borderColor: "#2f122e",
                      backgroundColor: "#fff",
                      "&:hover": { backgroundColor: "#f2edf3", borderColor: "#2f122e" },
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <span>{searching ? "Loading" : t("load_more")}</span>
                      {searching && <Loader />}
                    </span>
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SearchPage;
